import { render } from "./leaderboards-view.vue?vue&type=template&id=b3f156d8&lang=pug"
import script from "./leaderboards-view.vue?vue&type=script&lang=js"
export * from "./leaderboards-view.vue?vue&type=script&lang=js"

import exportComponent from "/builds/WebServers/festival/leaderboards/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__